module.exports = __webpack_public_path__ + "static/media/LineVerticalYellowColor.dbbdaf4c.svg";